<div class="badge" >
    <div class="line"></div>
    <span class="text"> {{ text }} </span>
</div>